import { render, staticRenderFns } from "./zaposleni-pripadnost.editor.vue?vue&type=template&id=0f1d0b9e&scoped=true&"
import script from "./zaposleni-pripadnost.editor.vue?vue&type=script&lang=ts&"
export * from "./zaposleni-pripadnost.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1d0b9e",
  null
  
)

export default component.exports